import React from "react";
import { useNavigate } from "react-router-dom";
import DateFormatting from "../../common_components/DateFormatting";
import UserIcon from "./UserIcon"
import { PrimaryButton } from "../../common_components/Buttons";

function UserToReviewCard(props) {
    const navigate = useNavigate();

    // Get the number of days between props.session.updated_at and the current time. 
    // If it's less than one, display "Applied recently". If it's more than one, display "Applied x days ago".
    const daysAgo = Math.floor(DateFormatting.daysAgo(props.mul.updated_at))
    const dayString = daysAgo < 1 ? 'Applied recently' : `Applied ${daysAgo} days ago`;

    return (
        <div className="completed-session-card gap-16 no-hover padding-16">
            <div className="user-to-review-card-content">
                <UserIcon />
                <div className="user-to-review-card-text-div">
                    <div className="completed-session-card-name">
                        {props.mul.first_name}
                    </div>
                    <div className="user-to-review-card-timestamp-container">
                        {dayString}
                    </div>
                </div>
            </div>
            <PrimaryButton onClick={() => navigate("/missions/" + props.missionId + "/reviewusers/" + props.mul.id)} text="Review" />
        </div>
    )
}

export default UserToReviewCard;